import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ProductFlag } from '../../../../enums/product-flag';

@Component({
  selector: 'app-product-flag-item',
  templateUrl: './product-flag-item.component.html',
  styleUrls: ['./product-flag-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductFlagItemComponent {
  @Input() productFlag: ProductFlag;

  get isLimitedInventory(): boolean {
    return this.productFlag === ProductFlag.LimitedInventory;
  }

  get isNew(): boolean {
    return this.productFlag === ProductFlag.New;
  }

  get isSale(): boolean {
    return this.productFlag === ProductFlag.Sale;
  }

  get isShipsSoon(): boolean {
    return this.productFlag === ProductFlag.ShipsSoon;
  }
}
